import { forwardRef } from 'react'
import { Icon } from 'components/Icon'
import { useTranslation } from 'hooks/useTranslation'
import { BarLabel, ChevronIcon, StickyFeedingBarRoot } from './StickyFeedingBar.styles'

type StickyFeedingBarProps = {
  isOpen: boolean
  onToggle: () => void
  panelId: string
}

export const StickyFeedingBar = forwardRef<HTMLButtonElement, StickyFeedingBarProps>(
  ({ isOpen, onToggle, panelId }, ref) => {
    const { t } = useTranslation()

    return (
      <StickyFeedingBarRoot
        ref={ref}
        type="button"
        onClick={onToggle}
        aria-expanded={isOpen}
        aria-controls={panelId}
      >
        <BarLabel>{t('blog:currently-feeding.mobile-bar-label')}</BarLabel>
        <ChevronIcon open={isOpen}>
          <Icon name="angle-left" size="2" />
        </ChevronIcon>
      </StickyFeedingBarRoot>
    )
  }
)

StickyFeedingBar.displayName = 'StickyFeedingBar'
